import React from 'react';
import {Spinner} from 'reactstrap';

export default () => (
    <div className='loading'>
        <Spinner size='lg' animation='border' role='status'>
            <span className='sr-only'>Loading...</span>
        </Spinner>
    </div>
)


// WEBPACK FOOTER //
// ./src/common/Spinner.js